<template lang="pug">
div
  paypal-button(v-for="fundingSource in fundingSources", :key="fundingSource", v-if="paypal.isFundingEligible(fundingSource)", :funding-source="fundingSource", :on-approve="onApprove", :create-order="createOrder", :on-error="onError", :on-cancel="onCancel", :style-object="{ color: 'gold' }")
</template>

<script>
import Vue from 'vue';

const PayPalButton = window.paypal.Buttons.driver('vue', Vue);

export default {
  components: {
    'paypal-button': PayPalButton
  },
  props: {
    createOrder: Function,
    returnUrl: String,
    cancelUrl: String
  },
  computed: {
    fundingSources: () => [
      window.paypal.FUNDING.PAYPAL,
      window.paypal.FUNDING.PAYLATER
    ],
    paypal: () => window.paypal
  },

  methods: {
    onApprove(data) {
      window.location.href = `${this.returnUrl}&token=${data.orderID}&PayerID=${data.payerID}`;
    },

    onError(err) {
      window.location.href = `/cart?agent=paypal&err=${err.code || '1'}`;
    },

    onCancel() {
      window.location.href = this.cancelUrl;
    }
  }
};
</script>
